import React from "react";

const LoadingSpinner = () => {
  return (
    <div className="loading-container" style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      width: '100%',
      position: 'fixed',
      left: '0',
      top: '0',
      background: 'rgba(0,0,0,0.6)',
      zIndex: '10'
    }}>
      <div className="spinner" style={{
        width: '50px',
        height: '50px',
        border: '5px solid rgba(0, 0, 0, 0.1)',
        borderLeftColor: '#764ba2',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite'
      }}></div>
      
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default LoadingSpinner;